import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Typography, makeStyles, Checkbox, FormControlLabel } from "componentLibrary";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    checkboxGroup: {
      padding: "16px 4px 18px"
    }
  };
});
var CheckboxGroup = function CheckboxGroup(_ref) {
  var options = _ref.options,
    onChange = _ref.onChange,
    parentKey = _ref.parentKey;
  var classes = useStyles();
  var onCheckboxChange = function onCheckboxChange(key) {
    var newOptions = _objectSpread({}, options);
    newOptions[key].active = !newOptions[key].active;
    onChange(newOptions, parentKey);
  };
  var getOptions = function getOptions(options) {
    var _context;
    return _mapInstanceProperty(_context = _Object$keys(options)).call(_context, function (key) {
      var _options$key = options[key],
        label = _options$key.label,
        active = _options$key.active;
      return /*#__PURE__*/_jsx(FormControlLabel, {
        control: /*#__PURE__*/_jsx(Checkbox, {
          checked: active,
          onChange: function onChange() {
            onCheckboxChange(key);
          },
          color: "secondary"
        }),
        label: label
      }, key);
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "checkbox-group-container",
    className: classes.checkboxGroup,
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_xsmall",
      wide: true,
      children: parentKey
    }), /*#__PURE__*/_jsx(_Fragment, {
      children: getOptions(options)
    })]
  });
};
export default CheckboxGroup;